import React, {useEffect, useState} from 'react';
import CompanyItem from "./CompanyItem";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";
import CreateBranchModal from "./CreateBranchModal";
import departments from "../../hrPages/Departments";
import {useHistory, useParams} from "react-router-dom";
import {Dropdown} from "antd";
import DeleteModal from "./DeleteModal";

const SectionsItem = () => {
    let history = useHistory()
    let params = useParams()
    const [selectData, setSelectData] = useState({})
    const [offices, setOffices] = useState([])
    const [addModal, setAddModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [type, setType] = useState(false);
    const [selectId, setSelectId] = useState(null)
    const [users, setUsers] = useState([])
    let level = 2

    const [perList, setPerList] = useState([])

    const getMe = () => {
        axios.get(API_PATH + "user/me", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setPerList(res.data?.permission_actions)
            })
    }

    const getAllData = () => {
        axios.get(API_PATH + "company/" + localStorage.getItem("id") + "/branch/branch/all?parent_id="+ params?.secId + "&hierarchy=2", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getUsers = (id) => {
        axios.get(API_PATH + "company/" + localStorage.getItem("id") + "/branch/"+ id + "/user/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setUsers(res.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getItemData = (id) => {
        axios.get(API_PATH + "company/" + localStorage.getItem("id") + "/branch/"+ id , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setSelectData(res.data)
                setAddModal(true)
                setType(true)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    useEffect(() => {
        getAllData()
        getMe()
    }, [params?.secId]);
    return (
      <>
          <div className="CompanyItem">
              <h3>Разделы</h3>
              {
                  perList?.filter(item => item === "view_branch").length > 0
                  ?
                      <div className="CompanyItem-list">
                          {
                              offices?.map((item, index) =>(
                                  <div className={item?.id === Number(params?.brId) ? "CompanyItem-box CompanyItem-box-active se-box" : "CompanyItem-box se-box"}
                                       onClick={() => history.push("/main/hierarchy/company/" + params?.secId + "/" + item?.id)}>
                                      <div className="CompanyItem-box-header">
                                          <h4>{item?.branch_title}</h4>


                                          <div className="controls">


                                              <Dropdown
                                                  // menu={{
                                                  //     items,
                                                  // }}
                                                  overlay={(
                                                      <ul className="ant-select-dropdown-my">
                                                          {
                                                              perList?.filter(item => item === "change_branch").length > 0
                                                                  ?
                                                                  <button className="dp-btn" onClick={() => getItemData(item?.id)}>
                                                                      <div className="img-icon">
                                                                          <img src="/icon/dp1.svg" alt="do"/>
                                                                      </div>
                                                                      <div className="dp-title">
                                                                          Редактировать раздел
                                                                      </div>
                                                                  </button>
                                                                  :
                                                                  ""
                                                          }
                                                          {
                                                              perList?.filter(item => item === "delete_branch").length > 0
                                                                  ?
                                                                  <button className="dp-btn" onClick={() => {
                                                                      setSelectId(item?.id)
                                                                      setDeleteModal(true)
                                                                  }}>
                                                                      <div className="img-icon">
                                                                          <img src="/icon/dp4.svg" alt="do"/>
                                                                      </div>
                                                                      <div className="dp-title">
                                                                          Удалить раздел
                                                                      </div>
                                                                  </button>
                                                                  :
                                                                  ""
                                                          }


                                                      </ul>
                                                  )}
                                                  placement="bottomRight"
                                              >
                                                  <button className="ver-dot-control">
                                                      <img src="/icon/verdotlight.svg" alt="..."/>
                                                  </button>
                                              </Dropdown>
                                          </div>
                                      </div>
                                      <div className="CompanyItem-box-header mt-2">
                                          <div className="info-build-item">
                                              <img src="/icon/Icon92.svg" alt=""/>
                                              <span>{item?.inheritance_count}</span>
                                          </div>
                                          <div className="controls">
                                              <div
                                                  className={item?.id === Number(params?.brId) ? "imgs-list imgs-list-active" : "imgs-list"}>
                                                  <Dropdown
                                                      trigger={['click']}
                                                      overlay={(
                                                          <ul className="ant-select-dropdown-my">
                                                              {
                                                                  users?.map((item2, index2) =>(
                                                                      <li className="ant-select-item-option-content-my">
                                                                          <div className="d-flex align-items-center">
                                                                              <div className="user-icon dp-user-icon">
                                                                                  <img src={item2?.image} alt="img" className="mr-8" style={{width: "32", height: "32", objectFit: "cover", borderRadius: "50%"}}/>

                                                                              </div>
                                                                              <div className="detail">
                                                                                  <div className="user-name">
                                                                                      {item2?.first_name + " " + item2?.last_name}
                                                                                  </div>
                                                                                  <div className="d-flex align-items-center">
                                                                                      <div className="position">
                                                                                          {item2?.role?.name  }
                                                                                      </div>
                                                                                      {/*<div className="action">*/}
                                                                                      {/*    <button><img src="/icon/editdark.svg" alt=""/>*/}
                                                                                      {/*    </button>*/}
                                                                                      {/*</div>*/}
                                                                                      {/*<div className="action">*/}
                                                                                      {/*    <button><img src="/icon/deletedark.svg" alt=""/>*/}
                                                                                      {/*    </button>*/}
                                                                                      {/*</div>*/}
                                                                                  </div>
                                                                              </div>
                                                                          </div>
                                                                      </li>

                                                                  ))
                                                              }
                                                              {
                                                                  users?.length === 0
                                                                      ?
                                                                      <p className="m-2 text-white">Нет пользователей</p>
                                                                      :
                                                                      ""
                                                              }
                                                          </ul>
                                                      )}
                                                      placement="bottomRight"
                                                  >
                                                      <div className="d-flex" onClick={(e) => {
                                                          e.preventDefault()
                                                          getUsers(item?.id)
                                                      }}>
                                                          <div className="img-item">
                                                              <img src="/icon/profileUser.png" alt="user"/>
                                                          </div>
                                                          <div className="img-item">
                                                              <img src="/icon/profileUser.png" alt="user"/>
                                                          </div>
                                                          <div className="img-item">
                                                              <img src="/icon/profileUser.png" alt="user"/>
                                                          </div>
                                                          <div className="img-item">
                                                              <img src="/icon/profileUser.png" alt="user"/>
                                                          </div>
                                                      </div>
                                                  </Dropdown>

                                              </div>
                                          </div>
                                      </div>

                                      <div className="CompanyItem-box-content">
                                          <div className="info">
                                              <div className="info-list">
                                                  <div className="info-item">
                                                      <div className="orange">{item?.employee_count}</div>
                                                      <span>Сотрудник</span>
                                                  </div>
                                                  <div className="info-ver-line"/>
                                                  <div className="info-item">
                                                      <div className="green">{item?.camera_count}</div>
                                                      <span>Камера</span>
                                                  </div>
                                                  <div className="info-ver-line"/>
                                                  <div className="info-item">
                                                      <div className="green">{item?.smart_camera_count}</div>
                                                      <span>Face camera</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              ))
                          }

                          {
                                  perList?.filter(item => item === "add_branch").length > 0
                                  ?
                                      <button className="SectionItem-add"  onClick={() => {
                                          setSelectData({})
                                          setAddModal(true)
                                      }}>
                                          <img src="/icon/bigPlus.svg" alt=""/>
                                      </button>
                                      :
                                      ""
                          }

                      </div>
                      :
                      ""
              }

          </div>

          {
              addModal
                  ?
                  <CreateBranchModal
                      title="Section"
                      isModal={addModal}
                      setIsModal={setAddModal}
                      getAllData={getAllData}
                      selectData={selectData}
                      level={level}
                      type={type}
                      parent_id={params?.secId}
                  />

                  :
                  ""
          }
          {
              deleteModal
                  ?
                  <DeleteModal
                      isModal={deleteModal}
                      setIsModal={setDeleteModal}
                      selectId={selectId}
                      getAllData={getAllData}
                  />
                  :
                  ""
          }

      </>
    );
};

export default SectionsItem;